"use client"

import { useState, useCallback } from "react"
import CategoryServices from "@/http/api/category/CategoryServices"

interface Data {
    id: string
    title: string
}

const { getVariationOptionTitle } = new CategoryServices()

export function useVariationFilter() {
    const [data, setData] = useState<Data[]>([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    const fetchVariation = useCallback(async (ids: number[]) => {
        if (!ids.length) return

        setLoading(true)
        setError(null)

        try {
            const responses : any = await Promise.all(ids.map(id => getVariationOptionTitle(id)))
            const results : any = responses.map((res : any) => ({ id: res.data.id, title: res.data.title }))

            setData(results)
        } catch (err) {
            setError(err instanceof Error ? err.message : "Unknown error")
        } finally {
            setLoading(false)
        }
    }, [])

    return { data, loading, error, fetchVariation }
}
